import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';

import Column from './base.jsx';

import ColumnLabels from '@data/nft-collections/columns.json';


var columnOptions = {
  id: 'i',
  title: 'Token Symbol'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get overlayText() {
    return ColumnLabels.symbol.description;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td>
        {this.props.row.symbol}
      </td>
    );
  }
}


class Symbol extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.symbol < b.symbol) {
      return -1;
    }
    if (a.symbol > b.symbol) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.symbol < b.symbol) {
      return 1;
    }
    if (a.symbol > b.symbol) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default Symbol;

